import { Link } from "react-router-dom";
import { METIERS_LIST } from "@/data/seoMetiers";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#3F3F3F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_c50239db-e303-4ac2-9fad-ed65c9848429/artifacts/15vvszb2_LOGO-FR-INTERIM-W.png"
              alt="FR INTERIM"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              L'expertise logistique au service de votre performance.
              Agence de travail temporaire spécialisée dans les métiers de la logistique.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#E5CD96] mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { to: "/", label: "Accueil" },
                { to: "/entreprise", label: "Entreprises" },
                { to: "/candidats", label: "Candidats" },
                { to: "/avantages", label: "Avantages" },
                { to: "/offres", label: "Offres d'emploi" },
                { to: "/actualites", label: "Actualités" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-gray-300 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Nos métiers (SEO interne) */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#E5CD96] mb-4">Nos métiers</h4>
            <ul className="space-y-2">
              {METIERS_LIST.map((m) => (
                <li key={m.slug}>
                  <Link to={`/metiers/${m.slug}`} className="text-sm text-gray-300 hover:text-white transition-colors" data-testid={`footer-metier-${m.slug}`}>
                    {m.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#E5CD96] mb-4">Spécialiste en logistique</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>FR INTERIM</p>
              <p>Agence de travail temporaire</p>
              <p>Spécialiste supply chain</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-600 text-center">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} FR INTERIM. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
